import React, { useEffect, useState } from "react";
import { IFilter } from "../../../../../types/filter.type";
import WrapperFilter from "../WrapperFilter";
import FilterText from "../FilterText";
import FilterSelectApi from "../FilterSelectApi";

function FilterParticipant({ loading, setCondition }: IFilter) {
  const originFilter: { [key: string]: any } = {
    email: "",
    name: "",
    usergroup: null,
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);

  const refreshFilter = () => {
    setFilter(originFilter);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = {};
    if (filter.email) {
      condition.email = {
        $regex: filter.email?.split(" ")?.join(".*"),
        $options: "i",
      };
    }
    if (filter.name) {
      condition.name = {
        $regex: filter.name?.split(" ")?.join(".*"),
        $options: "i",
      };
    }
    if (filter.usergroup) {
      condition.group_id = filter.usergroup?._id;
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterText
        label="Tài khoản"
        placeholder="Tìm theo tài khoản"
        value={filter.email}
        onSearch={(val) => setFilter({ ...filter, email: val })}
      />
      <FilterText
        label="Tên"
        placeholder="Tìm theo tên"
        value={filter.name}
        onSearch={(val) => setFilter({ ...filter, name: val })}
      />
      <FilterSelectApi
        direction="column"
        label="Nhóm"
        placeholder="Chọn nhóm"
        selectTitle="Chọn nhóm"
        placeholderSearch="Tìm theo tên nhóm"
        apiCode="usergroup"
        searchFields={["group_name"]}
        getOptionLabel={(option) => option.group_name}
        checkEqual={(value, option) => value?._id === option?._id}
        value={filter.usergroup}
        onChange={(val) => setFilter({ ...filter, usergroup: val })}
      />
    </WrapperFilter>
  );
}

export default FilterParticipant;
